'use client'

import { Box } from 'lucide-react'
import React from 'react'

interface Feature {
  title: string
  desc: string
}

interface ServiceFeaturesProps {
  features: Feature[]
  gradient: string
  title?: string
}

/* 
  ServiceFeatures - Based on "Variant 2: Holographic Cards"
*/
export default function ServiceFeatures({ features, gradient, title }: ServiceFeaturesProps) {
  if (!features || features.length === 0) return null

  return (
    <section className="relative z-10 w-full">
      <h2 className="home-title mb-8 sm:mb-12">{title || 'Что включает'}</h2>

      <div className="grid gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {features.map((feature, i) => (
          <div key={i} className="group relative">
            {/* Animated Border Gradient */}
            <div
              className={`absolute -inset-[1px] rounded-[30px] bg-gradient-to-r ${gradient} opacity-0 blur-md transition-opacity duration-500 group-hover:opacity-50`}
            />

            <div className="relative h-full overflow-hidden rounded-[28px] border border-white/10 bg-[#080c14] p-1 transition-all group-hover:border-white/0">
              {/* Inner Content */}
              <div className="relative h-full rounded-[24px] bg-[#0c1220]/80 p-6 backdrop-blur-xl transition-all group-hover:bg-[#0c1220]/60 sm:p-8">
                <div className="relative mb-6 sm:mb-8">
                  <div
                    className={`h-14 w-14 rounded-2xl bg-gradient-to-br ${gradient} p-[1px] shadow-[0_0_30px_-10px_rgba(255,255,255,0.2)]`}
                  >
                    <div className="flex h-full w-full items-center justify-center rounded-2xl bg-[#0c1220] transition-colors duration-500 group-hover:bg-transparent">
                      <Box className="h-6 w-6 text-white" />
                    </div>
                  </div>
                  {/* Connection Line */}
                  <div className="absolute top-14 -bottom-8 left-7 h-[50px] w-[1px] bg-gradient-to-b from-white/10 to-transparent transition-all group-hover:from-white/30" />
                </div>

                <h3 className="home-card-title-sm mb-4 flex items-center gap-3 leading-tight text-white">
                  {feature.title}
                </h3>
                <p className="home-subnote border-t border-white/5 pt-4 leading-relaxed text-gray-400">
                  {feature.desc}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
